<ng-container *ngTemplateOutlet="conteudoInfo"></ng-container>

<!-- Template de Header -->
<ng-template #headerTemplate>
  <!-- Status Bar -->
  <div class="w-full">
    <div
      class="pr-1 pl-1 pb-2 pt-2 border-round-lg lg:col-12"
      [style.background]="
        agendamento.status === StatusAgendamento.CANCELADO
          ? 'linear-gradient(135deg, #c71746, #c71763)'
          : agendamento.status === StatusAgendamento.CONFIRMADO
          ? 'linear-gradient(135deg, #17c74c, #4bc46f)'
          : agendamento.status === StatusAgendamento.REALIZADO
          ? 'linear-gradient(135deg, #1e90ff, #75baff)'
          : 'linear-gradient(135deg, #d1b202, #d6ca6f)'
      "
      [ngClass]="{
        'n-status-canceled': agendamento.status === StatusAgendamento.CANCELADO,
        'n-status-approved': agendamento.status === StatusAgendamento.CONFIRMADO,
        'n-status-pending': agendamento.status === StatusAgendamento.PENDENTE,
        'n-status-realized': agendamento.status === StatusAgendamento.REALIZADO
      }"
    >
      <div class="n-header-content">
        <div class="sm:col-12 md:col-8">
          <span class="n-status-text text-white font-bold">
            {{
              agendamento.status === StatusAgendamento.CANCELADO
                ? ('BARDO_STATUS.CANCELADO' | translate)
                : agendamento.status === StatusAgendamento.CONFIRMADO
                ? ('BARDO_STATUS.CONFIRMADO' | translate)
                : agendamento.status === StatusAgendamento.REALIZADO
                ? ('BARDO_STATUS.REALIZADO' | translate)
                : ('BARDO_STATUS.PENDENTE' | translate)
            }}
            @if (agendamento.isEncaixe) {
            <span class="n-encaixe-chip"
              ><i class="pi pi-bolt"></i> {{ 'BARDO_AGENDA.ENCAIXE_LABEL' | translate }}</span
            >
            }
            @if (agendamento.isDomicilio) {
            <span class="n-domicilio-chip"
              ><i class="pi pi-home"></i> {{ 'BARDO_AGENDA.DOMICILIO_LABEL' | translate }}</span
            >
            }
          </span>
        </div>

        <div class="sm:col-12 md:col-4 flex align-items-center gap-2">
          <span
            class="n-status-date text-white font-medium date-badge bg-white-alpha-20 px-3 py-1 border-round-xl"
          >
            {{ formatarDataHoraAgendamento(agendamento.dataHora) }}
            @if (agendamento.valorServico; as valorServico) {
            <span class="n-status-price">
              {{ valorServico | moeda }}
            </span>
            }
          </span>
          @if (showCloseButton) {
          <button
            type="button"
            class="n-close-btn"
            (click)="fechar.emit()"
            [attr.aria-label]="'BARDO_AGENDA.CANCELAR' | translate"
          >
            <i class="pi pi-times"></i>
          </button>
          }
        </div>
      </div>
    </div>
    <div class="lg:col-12">
      <p-tabs [value]="activeTab()" libTabsInkbarFix>
        <p-tablist>
          @for (tab of tabs(); track tab.id) { @if (tabVisivel(tab.id)) {
          <p-tab
            [value]="tab.id"
            class="flex items-center !gap-2 text-inherit"
            (click)="onTabChange(tab.id)"
          >
            <i [class]="tab.icon"></i>
            <span class="n-display-none">{{ tab.label }}</span>
          </p-tab>
          } }
        </p-tablist>
      </p-tabs>
    </div>
  </div>
</ng-template>

<!-- Template de conteúdo compartilhado -->
<ng-template #conteudoInfo>
  @switch (activeTab()) { @case ('view') {
  <div class="n-modal-content">
    <div class="n-info-row">
      <div class="flex gap-3">
        <span class="n-info-icon n-bg-primary">
          <i class="pi pi-user"></i>
        </span>
        <span class="n-info-text">
          <span class="n-info-label">{{ $nicho().cliente.singular }}</span>
          <p>
            {{ agendamento.cliente?.nome || agendamento.nomeCliente || ('BARDO_CLIENTES.NAO_INFORMADO' | translate) }}
          </p>
        </span>
      </div>

      <div class="flex gap-3">
        <span class="n-info-icon n-bg-primary">
          <i class="pi pi-phone"></i>
        </span>
        <span class="n-info-text">
          <span class="n-info-label">{{ 'BARDO_CLIENTES.TELEFONE' | translate }}</span>
          <p>
            @if (agendamento.cliente?.telefone || agendamento.telefoneCliente) {
            {{ formatarTelefone(agendamento.cliente?.telefone || agendamento.telefoneCliente) }}
            } @else if (agendamento.responsavelTelefone) {
            <span class="text-500 font-medium">
              {{ formatarTelefone(agendamento.responsavelTelefone) }} ({{ 'BARDO_CLIENTES.RESPONSAVEL' | translate }})
            </span>
            } @else { — }
          </p>
        </span>
      </div>
    </div>

    @if (agendamento.responsavelNome) {
    <div class="n-info-row n-dependente-row">
      <div class="flex gap-3 w-full">
        <span class="n-info-icon n-bg-warn">
          <i class="pi pi-users"></i>
        </span>
        <span class="n-info-text">
          <span class="n-info-label">{{ 'BARDO_CLIENTES.DEPENDENTE' | translate }} — {{ 'BARDO_CLIENTES.RESPONSAVEL_CONTATO' | translate }}</span>
          <p class="font-semibold">{{ agendamento.responsavelNome }}</p>
          @if (agendamento.responsavelTelefone) {
          <p class="n-responsavel-phone">
            <i class="pi pi-phone text-xs mr-1"></i>
            {{ formatarTelefone(agendamento.responsavelTelefone) }}
          </p>
          }
        </span>
      </div>
    </div>
    }

    <div class="n-info-row">
      <div class="flex gap-3">
        <span class="n-info-icon n-bg-primary">
          <i class="pi pi-briefcase"></i>
        </span>
        <span class="n-info-text">
          <span class="n-info-label">{{ $nicho().servico.singular }}</span>
          <p>
            {{ agendamento.servico?.nome || ('BARDO_CLIENTES.NAO_INFORMADO' | translate) }}
          </p>
        </span>
      </div>

      <div class="flex gap-3">
        <span class="n-info-icon n-bg-primary">
          <i class="pi pi-id-card"></i>
        </span>
        <span class="n-info-text">
          <span class="n-info-label">{{ $nicho().profissional.singular }}</span>
          <p>
            {{ agendamento.profissional?.nome || ('BARDO_CLIENTES.NAO_INFORMADO' | translate) }}
          </p>
        </span>
      </div>
    </div>


    @if (agendamento.isDomicilio) {
    <div class="n-info-row">
      <div class="flex gap-3 w-full">
        <span class="n-info-icon n-bg-primary">
          <i class="pi pi-home"></i>
        </span>
        <span class="n-info-text">
          <span class="n-info-label">{{ 'BARDO_AGENDA.ATENDIMENTO_DOMICILIO' | translate }}</span>
          <p>{{ agendamento.endereco || ('BARDO_CLIENTES.NAO_INFORMADO' | translate) }}</p>
        </span>
      </div>
    </div>

    @if (agendamento.historicoAtendimento?.length) {
    <div class="n-observacao">
      <p class="n-observacao-label">{{ 'BARDO_AGENDA.HISTORICO_ATENDIMENTO' | translate }}</p>
      @for (item of agendamento.historicoAtendimento; track item.dataHora) {
      <div class="n-observacao-content">
        <p>{{ rotuloStatus(item.status) }} — {{ formatarDataHoraAgendamento(item.dataHora) }}</p>
        <p>{{ item.geolocalizacao }}</p>
        <p>{{ 'BARDO_AGENDA.DISPOSITIVO' | translate }}: {{ rotuloDispositivo(item.disposivo) }}</p>
      </div>
      }
    </div>
    }
    }

    <!-- Observação (apenas se cancelado) -->
    @if (agendamento.observacao) {
    <div class="n-observacao">
      <p class="n-observacao-label">{{ 'BARDO_CLIENTES.OBSERVACAO' | translate }}:</p>
      <div class="n-observacao-content">
        {{ agendamento.observacao || ('BARDO_AGENDA.SEM_OBSERVACOES' | translate) }}
      </div>
    </div>
    }
  </div>
  } @case ('cancelar') {
  <div class="n-modal-content flex flex-column gap-3">
    <div class="n-cancel-alert">
      <span class="n-cancel-alert-icon">
        <i class="pi pi-exclamation-triangle"></i>
      </span>
      <div class="n-cancel-alert-text">
        <span class="n-cancel-alert-title">{{ 'BARDO_AGENDA.CANCELAR_AGENDAMENTO' | translate: { termo: ($nicho().agendamento.singular | lowercase) } }}</span>
        <span class="n-cancel-alert-desc"
          >{{ 'BARDO_AGENDA.ACAO_IRREVERSIVEL' | translate }}</span
        >
      </div>
    </div>
    <div class="flex flex-column gap-1">
      <label for="motivoCancelamento" class="n-cancel-label"
        >{{ 'BARDO_AGENDA.MOTIVO_CANCELAMENTO' | translate }} <span class="n-cancel-required">*</span></label
      >
      <textarea
        id="motivoCancelamento"
        pTextarea
        rows="4"
        autoResize="true"
        [maxlength]="maxObservacaoLength"
        [placeholder]="'BARDO_AGENDA.MOTIVO_CANCELAMENTO_PLACEHOLDER' | translate"
        [ngModel]="observacaoCancelamento()"
        (ngModelChange)="observacaoCancelamento.set($event)"
        class="n-cancel-textarea"
      ></textarea>
      <div class="n-cancel-counter">
        <div
          class="n-cancel-counter-bar"
          [style.width.%]="
            (observacaoCancelamento().length / maxObservacaoLength) * 100
          "
          [class.n-counter-warn]="
            observacaoCancelamento().length / maxObservacaoLength >= 0.8
          "
        ></div>
      </div>
      <span
        class="n-cancel-count-text"
        [class.n-count-warn]="
          observacaoCancelamento().length / maxObservacaoLength >= 0.8
        "
      >
        {{ observacaoCancelamento().length }}/{{ maxObservacaoLength }}
      </span>
    </div>
  </div>
  } @case('reagendar'){
  <lib-agenda-novo-agendamento
    [agendamento]="agendamento"
    (headerTemplateAction)="onChildHeaderTemplate($event)"
    (footerTemplateAction)="onChildFooterTemplate($event)"
    (agendamentoSalvo)="fechar.emit()"
  ></lib-agenda-novo-agendamento>
  } }
</ng-template>

<!-- Template de Footer -->
<ng-template #footerTemplate>
  @switch (activeTab()) { @case ('view') {
  <div class="w-full" style="padding: 0">
    <!-- Botões para Pendente -->
    @if (agendamento.status === StatusAgendamento.PENDENTE) {

    <p-button
      class="w-full"
      [label]="'BARDO_AGENDA.CONFIRMAR_AGENDAMENTO' | translate: { termo: $nicho().agendamento.singular }"
      styleClass="p-button-primary p-button-filled w-full"
      icon="pi pi-check"
      [loading]="AgendaDataService.$isLoadingModalInformacao()"
      [disabled]="
        !connectionService.$isOnline() ||
        AgendaDataService.$isLoadingModalInformacao()
      "
      (onClick)="confirmarAgendamento()"
    />

    }

    <!-- Botões para Confirmado -->
    @if (agendamento.status === StatusAgendamento.CONFIRMADO) {
    <div class="w-full">
      <p-button
        [label]="'BARDO_AGENDA.ATENDIMENTO_FINALIZADO' | translate"
        styleClass="p-button-primary p-button-filled w-full"
        icon="pi pi-check"
        [disabled]="!connectionService.$isOnline()"
        (onClick)="finalizarAtendimento()"
      />
    </div>
    }
  </div>
  } @case ('cancelar') {
  <div class="w-full">
    <p-button
      [label]="'BARDO_AGENDA.CONFIRMAR_CANCELAMENTO_BTN' | translate"
      styleClass="p-button-primary p-button-filled w-full"
      icon="pi pi-check"
      [disabled]="
        !connectionService.$isOnline() ||
        !observacaoCancelamento().trim().length
      "
      (onClick)="confirmarCancelamento()"
    />
  </div>
  } }
</ng-template>
